import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { bundleKeys } from "./bundle-keys";

// CLAUDE.md rule 4: type from BE schema, not hand-rolled.
export type CreateBundleBody = components["schemas"]["CreateListingRequest"];

export function useCreateBundle() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateBundleBody) => {
      const { data, error } = await apiClient.POST("/v1/listings", { body });
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: bundleKeys.all });
    },
  });
}
